<template>
  <div>
    <md-card>
      <md-card-content>
        <md-layout md-gutter>
          <md-layout md-flex="10">
            <md-button
              class="md-raised md-primary md-button-color md-theme-default back"
              style=" margin-top"
              @click="previousQuotation"
            >&laquo; Back</md-button>
          </md-layout>
        </md-layout>
        <hr class="hr-s" />

        <md-layout md-gutter>
          <md-layout md-flex="5"></md-layout>
          <!-- <md-layout md-flex="20">
            <md-layout md-flex="100">
              <label for="movie">Select Hub</label>
              <md-select name="HubId" id="HubID" v-model="HubId" @change="getData()">
                <md-option
                  v-for="(hub,index) in hubMaster"
                  :key="index"
                  :value="hub.hubId"
                >{{hub.hubName }}</md-option>
              </md-select>
            </md-layout>
          </md-layout>-->
        </md-layout>
        <hr class="hr-border" />

        <div class="box">
          <div class="box-header">
            <h3 class="box-title">{{HubName}}</h3>
          </div>
          <!-- /.box-header -->
          <div class="box-body" v-if="truckAvability.length>0">
            <table id="Hub1" class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Vehicle Size</th>
                  <th>Available Truck</th>
                  <th>Booked Truck</th>
                  <th>Total Truck</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in truckAvability" :key="index">
                  <td>{{item.vehicleType}}</td>
                  <td style="color:green">{{item.available}}</td>
                  <td style="color:red">{{item.total - item.available}}</td>
                  <td>{{item.total}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- /.box-body -->
        </div>

        <div class="box" v-if="truckAvability.length<=0">
          <!-- /.box-header -->
          <div class="box-body">
            <table id="Hub1" class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Vehicle Size</th>
                  <th>Available Truck</th>
                  <th>Booked Truck</th>
                  <th>Total Truck</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in truckAvability" :key="index">
                  <td>{{item.vehicleType}}</td>
                  <td style="color:green">{{item.available}}</td>
                  <td style="color:red">{{item.total - item.available}}</td>
                  <td>{{item.total}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- /.box-body -->
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>


<script>
import Vue from "vue";
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../../helper/filters";

export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.getData();
    } else {
      this.$router.push({
        path: "/Login/"
      });
    }
  },
  data() {
    return {
      HubName: "Hub",
      HubId: "",
      hubMaster: [],
      truckAvability: [
        {
          size: "",
          total: "",
          booked: "",
          available: ""
        }
      ]
    };
  },

  mounted() {},
  beforeDestroy() {},

  components: {},
  computed: {},
  methods: {
    JqueryFun() {
      return $(function() {
        return $("#Hub1").DataTable();
        return $("#Hub2").DataTable();
      });
    },

    previousQuotation() {
      this.$sessionsStorage.set("hubLocationMaster", this.HubId);
      this.$router.push({
        path: "/vehicle/quotation"
      });
    },
    getData() {
      this.truckAvability = [];

      let body = {
        hubId: this.HubId,
        view: "avail"
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/viewAvability.php`,
        data: JSON.stringify(body),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          console.log(result.data);

          this.truckAvability = result.data.truckAvability;
          this.HubName = result.data.hubName;
          this.HubId = result.data.hubId;
          this.hubMaster = result.data.hubMaster;

          console.log(this.HubId);
          this.JqueryFun();
        })
        .catch(error => {});
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.date-mrg {
  margin-top: -24px;
}
.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>




// WEBPACK FOOTER //
// vehicleAvailability.vue?2df2a71c